import service from '@/utils/server';
let modelPath = '/bd/orderMivManualNotice';
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post',
        data
    })
};
//
export const addOrderMivManualNotice = data => {
  return service({
    url: modelPath+'/add',
    method: 'post',
    data
  })
};

//查询退货申请单中间表详情
export const initUpdate = data => {
  return service({
    url: modelPath+'/initUpdate/' + data,
    method: 'post',
    data
  });
};

//订单详情-列表信息
export const orderDetailInfo = data => {
  return service({
    url: modelPath + '/orderDetailInfo',
    method: 'post',
    data
  })
}

//
export const updateOrderMivManualNotice = data => {
  return service({
    url: modelPath+'/update',
    method: 'post',
    data
  })
};

//manualNotice
export const manualNotice = data => {
  return service({
    url: modelPath + '/manualNotice/'+data,
    method: 'post'
  });
};

//
export const getDeleteOrderMivManualNoticeList = data => {
  return service({
    url: modelPath+'/delete/'+data.id,
    method: 'post'
  })
};






// WEBPACK FOOTER //
// ./src/page/bd/orderMivManualNotice/api/index.js